export default __webpack_public_path__ + "static/media/signupImage.dc7e57f8.jpg";